const trainingResEditor = () => import('@/training/pages/resource/resourceEdit');
const fibResEditor = () => import('@/pages/student/editStudent');
const jobResEditor = () => import('@/job/pages/member/edit');

export default [
  {
    name: 'fib_res_editor',
    path: '/student/edit/:id',
    component: fibResEditor,
    meta: { c: 'student', a: 'edit' }
  },
  {
    name: 'training_res_editor',
    path: '/customer/edit/:id',
    component: trainingResEditor,
    meta: { c: 'customer', a: 'edit' }
  },
  {
    name: 'job_res_editor',
    path: '/member/edit/:id',
    component: jobResEditor,
    meta: { c: 'member', a: 'edit' }
  },
  {
    name: 'fib_res_viewer',
    path: '/fib/view/:from/:id',
    component: fibResEditor,
    meta: { c: 'fib', a: 'view', site: 'fib' }
  },
  {
    name: 'training_res_viewer',
    path: '/training/view/:from/:id',
    component: trainingResEditor,
    meta: { c: 'training', a: 'view', site: 'training' }
  },
  {
    name: 'job_res_viewer',
    path: '/job/view/:from/:id',
    component: jobResEditor,
    meta: { c: 'job', a: 'view', site: 'job' }
  },
];
